import React from 'react';

const Signup = () => {
    return (
        <div style={{ height: '100vh' }}>
            <h2>Be Patience Developer is working on it</h2>
        </div>
    );
};

export default Signup;